import React from "react";
import SkeletonLoader from "shrimmer/SkeletonLoader";

const FeedbackUpperSurveyDetail = () => {
  return (
    <h3 className="dashboard_title">
      <SkeletonLoader type={"text"} height={26} width={250} rightGap={8} />
      <SkeletonLoader type={"text"} height={26} width={250} />
    </h3>
  );
};

export default FeedbackUpperSurveyDetail;
